<template>
    <p>Are you sure you want to delete this Country?</p>
    <br />
    <p>[ {{ item.name }} ]</p>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { type ICountry } from '@app/location/country/models/Country';
import { useCountryRepository } from '@app/location/country/repositories/useCountryRepository';

const props = defineProps({
    item: {
        type: Object as PropType<ICountry>,
        required: true,
    },
});

const destroy = useCountryRepository().command.destroy(props.item.id);
useInjectSubmitForm(destroy.execute);
</script>
